if (!customElements.get("story-popup")) {
    class StoryPopup extends HTMLElement {
        constructor() {
            super();
            this.videoTriggers = this.querySelectorAll('.td-popup__trigger') || null;
            this.popups = this.querySelectorAll('.td-popup__modal') || null;
            this.closers = this.querySelectorAll('.td-popup__modal-closer') || null;
        }
    
        connectedCallback() {
            if (this.videoTriggers.length > 0) {
                this.videoTriggers.forEach(trigger => {
                    trigger.addEventListener('click', () => {
                        if (trigger.dataset.triggerIndex) {
                            this.popups.forEach(popup => {
                                if (popup.dataset.popupIndex === trigger.dataset.triggerIndex) {
                                    popup.style.display = 'flex';
                                    let video = popup.querySelector('video')
                                    if (video) {
                                        video.play().catch(e => console.error('Error attempting to play video:', e))
                                    }
                                }
                            })
                        }
                    })
                })
            }
            if (this.closers.length > 0) {
                this.closers.forEach(closer => {
                    closer.addEventListener('click', () => {
                        this.popups.forEach(popup => {
                            let video = popup.querySelector('video')
                            if (video) {
                                video.pause()
                            }
                            popup.style.display = 'none';
                        })
                    })
                })
            }
        }
    }

    customElements.define("story-popup", StoryPopup);
}